<div class="bread-crumb-trail">
  <ol class="breadcrumb">
    <li
      class="breadcrumb-item"
      *ngFor="
        let breadcrumb of breadcrumbs;
        let first = first;
        trackBy: trackByValue
      "
    >
      <a [routerLink]="[breadcrumb.route]" [class.disabled]="first">
        {{ breadcrumb.title | translate }}
      </a>
    </li>
  </ol>

  <xvi-toolbar *ngIf="buttons && buttons.length > 0" [buttons]="buttons" class="button-group" ></xvi-toolbar>


  <div class="xvi-menu-wrapper">
    <div class="xvi-menu">
      <xvi-main-header *ngIf="!isIframeMode"></xvi-main-header>
    </div>
  </div>
</div>
